/**
 *   THIS CLASS CHECK FROM STORE PRODUCT
 *   ID AND CHECK FORM BACKEND IF THIS PRODUCT ID HAS ANY VALUES
 *   DOCUMENTS TO DOWNLOAD THEN ACTIVATE O DEACTIVATE CHECKBOX
 */
import Axios from "axios";
import is_localhost from "./class_is_localhost";
export default class get_document {
  getDocumentbyID(store) {
    let that = store;
    let params = new URLSearchParams();
    let ur = new is_localhost();
    let url = ur.return_url_website();
    params.append("action", "get_document");
    params.append("ID", store.product_store.CODICE_UNIVOCO);
    params.append("LANG", store.product.language);
    Axios.post(url + "wp-admin/admin-ajax.php", params)
      .then(function (response) {
        try {
          that.items.item1[0].active =
            response.data.SCHEDA_MONTAGGIO != null ? "active" : "disabled";
          // ogni volta che cambio prodotto chiedo al mio server se i file di quel particolare prodotto esistono
          if (that.product.language == "en") {
            that.items.item2[0].active =
              response.data.SCHEDA_COLLEZIONE_EN != false
                ? "active"
                : "disabled";
            // controllo se esiste almeno italiano anche se a questo punto io lascerei disabled
            if (that.items.item2[0].active == "disabled") {
              that.items.item2[0].active =
                response.data.SCHEDA_COLLEZIONE != null ? "active" : "disabled";
            }
          } else {
            that.items.item2[0].active =
              response.data.SCHEDA_COLLEZIONE != null ? "active" : "disabled";
          }

          if (that.product.language == "en") {
            that.items.item3[0].active = response.data.SCHEDA_COLLEZIONE_EN_SPEC
              ? "active"
              : "disabled";

            if (!response.data.SCHEDA_COLLEZIONE_EN_SPEC) {
              that.items.item3[0].active = response.data
                .SCHEDA_COLLEZIONE_EN_GEN
                ? "active"
                : "disabled";
            }
          } else {
            that.items.item3[0].active = response.data.SCHEDA_COLLEZIONE_SPEC
              ? "active"
              : "disabled";
            if (!response.data.SCHEDA_COLLEZIONE_SPEC) {
              that.items.item3[0].active = response.data.SCHEDA_COLLEZIONE_GEN
                ? "active"
                : "disabled";
            }
          }

          that.items.item4[0].active =
            response.data.MODELLI_2D != null ? "active" : "disabled";
          that.items.item5[0].active =
            response.data.MODELLI_3D != null ? "active" : "disabled";
          that.items.item6[0].active =
            response.data.LIBRERIA_TEXTURE != null ? "active" : "disabled";
          that.items.item7[0].active =
            response.data.DATI_EXTRA != null ? "active" : "disabled";
          that.button_download.disabled = true;

          if (that.items.item1[0].active == "disabled") {
            that.items.item1[0].selected = false;
          }
          if (that.items.item2[0].active == "disabled") {
            that.items.item2[0].selected = false;
          }
          if (that.items.item3[0].active == "disabled") {
            that.items.item3[0].selected = false;
          }
          if (that.items.item4[0].active == "disabled") {
            that.items.item4[0].selected = false;
          }
          if (that.items.item5[0].active == "disabled") {
            that.items.item5[0].selected = false;
          }
          if (that.items.item6[0].active == "disabled") {
            that.items.item6[0].selected = false;
          }
          if (that.items.item7[0].active == "disabled") {
            that.items.item7[0].selected = false;
          }
try{
          Object.keys(that.items).forEach((key) => {
            if (that.items[key][0].active == "active") {
              that.button_download.disabled = false;
            }
          });
        } catch (error) {
          console.info(error);
      }
        } catch (error) {
          console.info(error);
        }
      })
      .catch(function (error) {
        console.info(error);
      });
  }



  async getcodalt_async(store) {

    return await this.GETCODALT(store)
       .then((response) => {
         console.info(response)
       })
   }
  GETCODALT(store) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      let ur = new is_localhost();
      let url = ur.return_url_website();
      params.append("action", "getcodalt");
      params.append("vc", "getcodalt");
      params.append("ID", store.product_store.CODICE_UNIVOCO);
      Axios.post(url + "wp-admin/admin-ajax.php", params)
      .then(function (response) {
        resolve(response.data.Codice_alternativo_att);
      }).catch(function (error) {
        console.info(error);
        reject('')
      })
   }
    );
  }
}
